import { SERVICES_LIST, SERVICES_DETAIL, NOT_FOUND, LOADING } from "../action/type";

const initialState = {
  list: [{}],
  loading:false,
  not_found:false
};
const services = function (state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return { ...state, list: action.payload,loading:true,not_found:false };
    case NOT_FOUND:
    return { ...state, list: action.payload ,loading:false,not_found:true};
    case SERVICES_LIST:
      return { ...state, list: action.payload, loading:false,not_found:false };
    case SERVICES_DETAIL:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    default:
      return state;
  }
}

export default services